// @owners { team: patients-team }
import { type ConfirmShipmentRequest } from '@alto/scriptdash/alto/patient_app/homescreen/v1/confirm_shipment_endpoint';
import { put } from '~shared/helpers/apiHelper';
import { useMutation } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const confirmShipment = async ({
  id,
  date,
  start_time,
  end_time,
  address,
  price,
  medication_names,
  home_to_sign_required,
  waivable,
  waived,
}: ConfirmShipmentRequest) => {
  return await put(
    `/shipments/${id}/confirm_shipment`,
    {
      date,
      start_time,
      end_time,
      address,
      price,
      medication_names,
      home_to_sign_required,
      waivable,
      waived,
    },
    {
      version: 'v1',
    },
  );
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useConfirmShipment = () => {
  return useMutation({ mutationFn: confirmShipment });
};
